import * as actionTypes from 'src/old/actions';

const initialState = {
  modalType: null,
  modalProps: {
    open: false
  }
};

const modalReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SHOW_MODAL: {
      return {
        ...state,
        modalProps: { ...action.modalProps, open: true },
        modalType: action.modalType
      };
    }
    case actionTypes.HIDE_MODAL: {
      return {
        ...state,
        ...initialState
      };
    }

    default: {
      return state;
    }
  }
};

export default modalReducer;
